import _ from 'lodash';

export const COOKIE_ACCEPT_NAME = 'acceptcookie'

export function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = jQuery.trim(cookies[i]);
            if (cookie.substring(0, name.length + 1) == (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}


export function csrfSafeMethod(method) {
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

export function isCookieAccept() {
    const isCookieExists = getCookie(COOKIE_ACCEPT_NAME)
    return !_.isEmpty(isCookieExists)
}

export function acceptCookie() {
    setCookie(COOKIE_ACCEPT_NAME, '1')
}

function evalXCookieConsent(script) {
    var src = script.getAttribute("src")
    if (src) {
        var newScript = document.createElement('script');
        newScript.src = src;
        document.getElementsByTagName("head")[0].appendChild(newScript);
    } else {
        eval(script.innerHTML);
    }
    script.remove();
}

export function showCookieBarCustom (options) {
    const defaults = {
      cookie_groups: [],
      cookie_decline: null,
      beforeDeclined: null
    };
  
    const opts = Object.assign(defaults, options);
  
    document
    .querySelector(".cc-cookie-accept")
    .addEventListener('click', (e) => {
        e.preventDefault();
        fetch(e.target.getAttribute("href"), {method: "POST"})
        .then(() => {
            let scripts = document.querySelectorAll("script[type='x/cookie_consent']");
            scripts.forEach( (script) => {
                if (opts.cookie_groups.indexOf(script.getAttribute('data-varname')) != -1) {
                    evalXCookieConsent(script);
                }
            });
            window.location.reload(true) 
        })
    });
  
    document
    .querySelector(".cc-cookie-decline")
    .addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof opts.beforeDeclined === "function") {
            opts.beforeDeclined();
        }
        fetch(e.target.getAttribute("href"), {method: "POST"})
        .then(() => {
            if (opts.cookie_decline) {
                document.cookie = opts.cookie_decline;
            }
        })  
    });
}